import React, { useState } from 'react';
import { PlayIcon, ImageIcon, FilmIcon, ExternalLinkIcon, ShareIcon } from 'lucide-react';
export function TourAlbums() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeMedia, setActiveMedia] = useState<number | null>(null);
  const media = [{
    id: 1,
    type: 'image',
    thumbnail: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    full: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
    caption: 'Oia village with blue domed churches'
  }, {
    id: 2,
    type: 'video',
    thumbnail: 'https://images.unsplash.com/photo-1515859005217-8a1f08870f59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    duration: '2:15',
    caption: 'Walking tour of Oia'
  }, {
    id: 3,
    type: 'image',
    thumbnail: 'https://images.unsplash.com/photo-1567154878870-6a58a5354700?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    full: 'https://images.unsplash.com/photo-1567154878870-6a58a5354700?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
    caption: 'Santorini winery with caldera views'
  }, {
    id: 4,
    type: 'image',
    thumbnail: 'https://images.unsplash.com/photo-1601755114385-4301d48ae0f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    full: 'https://images.unsplash.com/photo-1601755114385-4301d48ae0f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
    caption: 'Wine tasting with local varieties'
  }, {
    id: 5,
    type: 'video',
    thumbnail: 'https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    duration: '1:45',
    caption: 'Santorini sunset timelapse'
  }, {
    id: 6,
    type: 'image',
    thumbnail: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    full: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
    caption: 'Sunset view from Oia'
  }];
  const filteredMedia = activeFilter === 'all' ? media : media.filter(item => item.type === activeFilter);
  return <section className="py-8" data-id="element-1469">
      <div className="container mx-auto px-4" data-id="element-1470">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6" data-id="element-1471">
          <h2 className="text-2xl font-bold text-gray-900 mb-2 sm:mb-0" data-id="element-1472">
            Tour Gallery{' '}
            <span className="text-sm font-normal text-gray-500" data-id="element-1473">
              (15 photos, 3 videos)
            </span>
          </h2>
          <div className="flex space-x-2" data-id="element-1474">
            <button className={`px-3 py-1.5 rounded-md text-sm font-medium ${activeFilter === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveFilter('all')} data-id="element-1475">
              All
            </button>
            <button className={`px-3 py-1.5 rounded-md text-sm font-medium flex items-center ${activeFilter === 'image' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveFilter('image')} data-id="element-1476">
              <ImageIcon size={14} className="mr-1" data-id="element-1477" />
              Photos
            </button>
            <button className={`px-3 py-1.5 rounded-md text-sm font-medium flex items-center ${activeFilter === 'video' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveFilter('video')} data-id="element-1478">
              <FilmIcon size={14} className="mr-1" data-id="element-1479" />
              Videos
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1480">
          {filteredMedia.map(item => <div key={item.id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden group" data-id="element-1481">
              <div className="aspect-[4/3] relative overflow-hidden cursor-pointer" onClick={() => {
            setActiveMedia(item.id - 1);
            setLightboxOpen(true);
          }} data-id="element-1482">
                <img src={item.thumbnail} alt={item.caption} className="w-full h-full object-cover transition-transform group-hover:scale-105" data-id="element-1483" />
                {item.type === 'video' && <>
                    <div className="absolute inset-0 bg-black bg-opacity-20" data-id="element-1484"></div>
                    <div className="absolute inset-0 flex items-center justify-center" data-id="element-1485">
                      <div className="w-12 h-12 rounded-full bg-white bg-opacity-80 flex items-center justify-center" data-id="element-1486">
                        <PlayIcon size={24} className="text-blue-600 ml-1" data-id="element-1487" />
                      </div>
                    </div>
                    <div className="absolute bottom-2 right-2 px-2 py-1 bg-black bg-opacity-70 rounded text-xs text-white" data-id="element-1488">
                      {item.duration}
                    </div>
                  </>}
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1489">
                  <button className="p-1.5 bg-white bg-opacity-80 rounded-full text-gray-700 hover:text-blue-600" data-id="element-1490">
                    <ShareIcon size={16} data-id="element-1491" />
                  </button>
                </div>
              </div>
              <div className="p-3" data-id="element-1492">
                <p className="text-sm text-gray-700 truncate" data-id="element-1493">{item.caption}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-6 text-center" data-id="element-1494">
          <button className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-1495">
            <span data-id="element-1496">View All Media</span>
            <ExternalLinkIcon size={16} className="ml-2" data-id="element-1497" />
          </button>
        </div>
        {/* Lightbox modal - simplified version */}
        {lightboxOpen && activeMedia !== null && <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center" onClick={() => setLightboxOpen(false)} data-id="element-1498">
            <div className="max-w-4xl max-h-[90vh] relative" data-id="element-1499">
              {media[activeMedia].type === 'image' ? <img src={media[activeMedia].full} alt={media[activeMedia].caption} className="max-w-full max-h-[80vh] object-contain" data-id="element-1500" /> : <div className="aspect-video w-full max-w-4xl bg-black flex items-center justify-center" data-id="element-1501">
                  <PlayIcon size={64} className="text-white opacity-70" data-id="element-1502" />
                </div>}
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-4" data-id="element-1503">
                <p data-id="element-1504">{media[activeMedia].caption}</p>
              </div>
            </div>
          </div>}
      </div>
    </section>;
}